import {
  Button,
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

const RoleAccessPage = ({
  userRoleAccessDetails,
  userRoleMappingId,
  AddRoleAccessService,
  fetchUserRoleAccess,
  setLoading,
  showNotification,
  loginUserInfo,
}) => {
  const [payload, setPayload] = useState([]);
  const [temp, setTemp] = useState([]);

  function createPayload(data) {
    const newRecords = {
      userRoleMappingId: userRoleMappingId,
      accessPermissionParamList: [],
    };
    data.forEach((item) => {
      item["permissionStatusResponseList"].forEach((i) => {
        newRecords.accessPermissionParamList.push({
          accessDataTypeId: item.accessDataTypeId,
          permId: i.permissionId,
          active: i.active,
        });
      });
    });
    setPayload(newRecords);
  }

  useEffect(() => {
    createPayload(userRoleAccessDetails);
    setTemp(userRoleAccessDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRoleAccessDetails]);

  const handleChange = (e, a, p) => {
    const t = [];
    temp.forEach((item) => {
      if (item?.accessDataTypeId === a) {
        t.push({
          accessDataTypeId: a,
          accessDataTypeName: item.accessDataTypeName,
          permissionStatusResponseList: item[
            "permissionStatusResponseList"
          ].map((i) => {
            return {
              permissionId: i.permissionId,
              permissionName: i.permissionName,
              active: i.permissionId === p ? e.target.checked : i.active,
            };
          }),
        });
      } else {
        t.push(item);
      }
    });
    setTemp(t);
    createPayload(t);
  };

  const onSubmit = async () => {
    try {
      setLoading(true);
      const response = await AddRoleAccessService(payload);
      if (response.statusCode === 6) {
        fetchUserRoleAccess(userRoleMappingId);
        showNotification("Success", response.message, "success");
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const onResetDetails = () => {
    createPayload(userRoleAccessDetails);
    setTemp(userRoleAccessDetails);
  };

  return (
    <Grid item xs={12} mb={4}>
      {userRoleAccessDetails && userRoleAccessDetails.length > 0 ? (
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 720, mb: 2 }}>
            <Table
              stickyHeader
              aria-label="sticky table"
              aria-labelledby="tableTitle"
              size="small"
            >
              <TableBody sx={{ mt: 2 }}>
                {userRoleAccessDetails.map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={index}>
                      <TableCell size="small" key={"accessDataTypeName"}>
                        {row["accessDataTypeName"] ?? "-"}
                      </TableCell>
                      {row["permissionStatusResponseList"].map((r, i) => {
                        return (
                          <TableCell size="small" key={i + Date.now()}>
                            <Checkbox
                            classes={{root: 'custom-checkbox-root'}}
                              checked={
                                payload?.accessPermissionParamList?.filter(
                                  (item) =>
                                    item.accessDataTypeId ===
                                      row["accessDataTypeId"] &&
                                    item.permId === r["permissionId"]
                                )[0]?.active
                              }
                              onChange={
                                loginUserInfo.userType !== "Domain Admin"
                                  ? (e) =>
                                      handleChange(
                                        e,
                                        row["accessDataTypeId"],
                                        r["permissionId"]
                                      )
                                  : null
                              }
                            />
                            {r["permissionName"]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {loginUserInfo.userType !== "Domain Admin" ? (
            <Typography align="right" sx={{ mb: 2, marginRight: 2 }}>
              {/* <Tooltip title="Sace User"> */}
              <Button
                variant="contained"
                onClick={onSubmit}
                sx={{ p: 1 }}
                className="button-primary-alt-contained"
              >
                Save
              </Button>
              {/* </Tooltip> */}
              {/* <Tooltip title="Add User"> */}
              <Button
                variant="contained"
                onClick={() => onResetDetails()}
                sx={{ p: 1, ml: 1 }}
                className="button-primary-alt-contained"
              >
                {" "}
                Reset
              </Button>
              {/* </Tooltip> */}
            </Typography>
          ) : null}
        </Paper>
      ) : (
        <Paper elevation={3} variant="elevation">
          {/* <RecordNotFound /> */}
        </Paper>
      )}
    </Grid>
  );
};

export default RoleAccessPage;
